import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReclamationRoutingModule } from './reclamation-routing.module';
import { CreateReclamationComponent } from './composants/create-reclamation/create-reclamation.component';
import { DetailrecComponent } from './composants/detailrec/detailrec.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [
    CreateReclamationComponent,
    DetailrecComponent,

  ],
  imports: [
    CommonModule,
    ReclamationRoutingModule,
    SharedModule
  ]
})
export class ReclamationModule { }
